module.exports = __webpack_public_path__ + "img/fin-academy-library.295953b1.svg";